import type { Transition } from 'motion/react';
import { AnimatePresence } from 'motion/react';
import * as motion from 'motion/react-m';
import { ImageComponent } from '@/components/Image';
import { ScBackgroundImage } from './styled';

interface IBackgroundImageProps {
  disableAnimation?: boolean;
  src: string;
}

const FADE_DURATION = 0.6;

const FADE_TRANSITION: Transition = {
  duration: FADE_DURATION,
  ease: 'easeInOut',
};

const HOLD_EXIT = {
  opacity: 0,
  transition: { delay: FADE_DURATION, duration: 0 },
};

export const BackgroundImage = ({
  disableAnimation,
  src,
}: IBackgroundImageProps) => (
  <ScBackgroundImage $disableAnimation={disableAnimation}>
    <AnimatePresence>
      <motion.div
        animate={{ opacity: 1 }}
        className="bgLayer"
        exit={HOLD_EXIT}
        initial={{ opacity: 0 }}
        key={src}
        transition={FADE_TRANSITION}
      >
        <ImageComponent alt="background" className="bg" fill src={src} />
      </motion.div>
    </AnimatePresence>
  </ScBackgroundImage>
);
